module.exports = __webpack_public_path__ + "static/img/black-friday.d9e3d5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/black-friday.png
// module id = qHLM
// module chunks = 1